import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const BASE_TITLE = 'PHI Printing';

const ROUTE_TITLES: Array<{ pattern: RegExp; title: string }> = [
  { pattern: /^\/$/, title: 'Custom Photo Printing & Art Reproductions' },
  { pattern: /^\/login$/, title: 'Login' },
  { pattern: /^\/register$/, title: 'Create Account' },
  { pattern: /^\/forgot-password$/, title: 'Forgot Password' },
  { pattern: /^\/reset-password$/, title: 'Reset Password' },
  { pattern: /^\/create-print$/, title: 'Create a Custom Print' },
  { pattern: /^\/art$/, title: 'Art Shop' },
  { pattern: /^\/art\/browse$/, title: 'Browse Gallery' },
  { pattern: /^\/artists\/[^/]+\/shop$/, title: 'Artist Shop' },
  { pattern: /^\/artists\/[^/]+$/, title: 'Artist Profile' },
  { pattern: /^\/artworks\/[^/]+$/, title: 'Artwork' },
  { pattern: /^\/cart$/, title: 'Shopping Cart' },
  { pattern: /^\/payment\/success$/, title: 'Payment Successful' },
  { pattern: /^\/payment\/cancel$/, title: 'Payment Cancelled' },
  { pattern: /^\/history$/, title: 'Purchase History' },
  { pattern: /^\/addresses$/, title: 'My Addresses' },
  { pattern: /^\/returns$/, title: 'My Returns' },
  { pattern: /^\/profile$/, title: 'My Profile' },
  { pattern: /^\/become-an-artist$/, title: 'Become an Artist' },
  { pattern: /^\/artist\/metrics$/, title: 'Artist Metrics' },
  { pattern: /^\/artist\/sales$/, title: 'Artist Sales' },
  { pattern: /^\/artist\/storefront$/, title: 'Artist Storefront' },
  { pattern: /^\/artist\/artworks$/, title: 'My Artworks' },
  { pattern: /^\/admin$/, title: 'Admin Dashboard' },
  { pattern: /^\/admin\/orders$/, title: 'Admin – Orders' },
  { pattern: /^\/admin\/users$/, title: 'Admin – Users' },
  { pattern: /^\/admin\/products$/, title: 'Admin – Products' },
  { pattern: /^\/admin\/artworks$/, title: 'Admin – Artworks' },
  { pattern: /^\/admin\/sizes$/, title: 'Admin – Sizes' },
  { pattern: /^\/admin\/aspect-ratios$/, title: 'Admin – Aspect Ratios' },
  { pattern: /^\/admin\/shipping$/, title: 'Admin – Shipping' },
  { pattern: /^\/admin\/material-pricing$/, title: 'Admin – Material Pricing' },
  { pattern: /^\/admin\/artists$/, title: 'Admin – Artists' },
  { pattern: /^\/admin\/artist-applications$/, title: 'Admin – Artist Applications' },
  { pattern: /^\/admin\/metrics$/, title: 'Admin – Metrics' },
  { pattern: /^\/admin\/settings$/, title: 'Admin – Settings' },
  { pattern: /^\/admin\/tags$/, title: 'Admin – Tags' },
  { pattern: /^\/admin\/(promotions|coupons|sales)$/, title: 'Admin – Promotions' },
  { pattern: /^\/admin\/returns$/, title: 'Admin – Returns' },
  { pattern: /^\/admin\/stretcher-bars$/, title: 'Admin – Stretcher Bars' },
  { pattern: /^\/terms$/, title: 'Terms of Service' },
  { pattern: /^\/privacy$/, title: 'Privacy Policy' },
  { pattern: /^\/cookies$/, title: 'Cookie Policy' },
  { pattern: /^\/copyright$/, title: 'Copyright & IP Policy' },
  { pattern: /^\/returns-policy$/, title: 'Returns & Refunds Policy' },
];

/**
 * Updates the document title and scrolls to top on every route change.
 * Detail pages may further refine the title once their data loads.
 */
const RouteChangeHandler: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const match = ROUTE_TITLES.find(({ pattern }) => pattern.test(pathname));
    document.title = match ? `${match.title} | ${BASE_TITLE}` : BASE_TITLE;
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default RouteChangeHandler;
